"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var GridCrossSell_1 = require("../components/ShopAll/GridCrossSell");
var targetNode = document.querySelector('.grid-cross-sell-section');
if (targetNode && window.preactCrossSellProducts) {
    (0, preact_1.render)((0, preact_1.h)(GridCrossSell_1.default, { products: window.preactCrossSellProducts }), targetNode);
}
